import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { EmphasizeMatchesPipe } from './emphasize.matches.pipe';
import { PrivacySensitiveDirective } from './privacy-sensitive.directive';
import { TypeAheadSuggestionsComponent } from './type-ahead/type-ahead-suggestions/type-ahead-suggestions.component';
import { TypeAheadComponent } from './type-ahead/type-ahead.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule],
  declarations: [
    TypeAheadComponent,
    TypeAheadSuggestionsComponent,
    EmphasizeMatchesPipe,
    PrivacySensitiveDirective
  ],
  exports: [TypeAheadComponent]
})
export class TypeAheadModule {}
